import {CSSProperties, forwardRef, useEffect, useMemo, useRef, useState} from "react";
import classNames from "classnames";

import {ManualPopover} from "@pg-design/floating-module";
import {SlimRange} from "@pg-design/range-module";

import {IMaxValueInputProps} from "../../types/IMaxValueInputProps";
import {getNumberFormat} from "../../utils/get_number_format";
import {Input} from "../input/Input";

import * as cns from "./MaxValueInput.module.css";

export const MaxValueInput = forwardRef<HTMLInputElement, IMaxValueInputProps>((props, forwardedRef) => {
    const {step, min, max, name, value, onChange, ...inputProps} = props;

    const [displayValue, setDisplayValue] = useState<number | string>(getNumberFormat(value ?? 0));
    const [warning, setWarning] = useState({isOpen: false, message: ""});
    const [inputWidth, setInputWidth] = useState(`${displayValue.toString().length}ch`);

    const warningHideRef = useRef<null | ReturnType<typeof setTimeout>>(null);
    const measureSpanRef = useRef<null | HTMLSpanElement>(null);

    const rangeValue = useMemo(() => {
        const noWs = getWithoutWhiteSpace(displayValue);

        return {
            upper: parseInt(noWs)
        };
    }, [displayValue]);

    useEffect(() => {
        const hiddenSpanObserver = new ResizeObserver((entries) => {
            for (const entry of entries) {
                setInputWidth(`${entry.contentRect.width}px`);
            }
        });

        if (measureSpanRef.current) {
            hiddenSpanObserver.observe(measureSpanRef.current);
        }

        return () => {
            hiddenSpanObserver.disconnect();
        };
    }, []);

    useEffect(() => {
        if (warning.isOpen) {
            warningHideRef.current = setTimeout(() => {
                setWarning({isOpen: false, message: warning.message});
            }, 2000);
        }

        return () => {
            if (warningHideRef.current) {
                clearTimeout(warningHideRef.current);
                warningHideRef.current = null;
            }
        };
    }, [warning.isOpen]);

    useEffect(() => {
        if (onChange) {
            const numValue = getWithoutWhiteSpace(displayValue);
            onChange(parseInt(numValue));
        }
    }, [displayValue]);

    return (
        <div
            className={cns.maxValueInput}
            style={
                {
                    "--input-width": inputWidth
                } as CSSProperties
            }
        >
            <SlimRange
                name={`${name}_range`}
                value={rangeValue}
                useDynamicChange
                onChange={(_, value) => {
                    if (value.upper) {
                        setDisplayValue(getNumberFormat(value.upper));
                    }
                }}
                step={step}
                min={min}
                max={max}
                className={classNames(cns.maxValueInputRange, inputProps.disabled && cns.maxValueInputRangeDisabled)}
                hideLabels
                disabled={inputProps.disabled}
            />
            <ManualPopover
                popover={warning.message}
                isOpen={warning.isOpen}
                type="warning"
                handleSetIsOpen={(isWarningOpen) => {
                    setWarning({isOpen: isWarningOpen, message: warning.message});
                }}
                className={cns.maxValueInputPopover}
            >
                {({refs, getReferenceProps}) => (
                    <div ref={refs.setReference} {...getReferenceProps()} className={cns.maxValueInputField}>
                        <span className={cns.maxValueInputHiddenSpan} ref={measureSpanRef}>
                            {displayValue}
                        </span>
                        <Input
                            ref={forwardedRef}
                            name={name}
                            {...inputProps}
                            value={displayValue}
                            inputWrapClassName={cns.maxValueInputWrapper}
                            inputClassName={cns.maxValueInputCore}
                            elementCustomClassName={classNames(
                                cns.maxValueInputCoreRightElement,
                                typeof inputProps.rightElement === "string" && inputProps.disabled && cns.maxValueInputDisabledStringElement
                            )}
                            onChange={(event) => {
                                const newValue = event.currentTarget.value;
                                const valueWithoutWhiteSpace = getWithoutWhiteSpace(newValue);
                                const isValueWithDigitsOnly = isOnlyWithDigits(valueWithoutWhiteSpace);

                                const newValueInt = parseInt(valueWithoutWhiteSpace) | 0;

                                if (!isValueWithDigitsOnly && !warning.isOpen) {
                                    setWarning({
                                        isOpen: true,
                                        message: "Dozwolone są tylko cyfry"
                                    });
                                    return;
                                }

                                if (isValueWithDigitsOnly && newValueInt < min) {
                                    setWarning({
                                        isOpen: true,
                                        message: `Minimalna wartość: ${min}`
                                    });
                                    setDisplayValue(getNumberFormat(min));
                                    return;
                                }

                                if (isValueWithDigitsOnly && newValueInt > max) {
                                    setWarning({
                                        isOpen: true,
                                        message: `Maksymalna wartość: ${max}`
                                    });
                                    setDisplayValue(getNumberFormat(max));
                                    return;
                                }

                                if (isValueWithDigitsOnly && newValueInt >= min && newValueInt <= max) {
                                    setDisplayValue(getNumberFormat(newValueInt));
                                    return;
                                }
                            }}
                        />
                    </div>
                )}
            </ManualPopover>
        </div>
    );
});

// Utils
function getWithoutWhiteSpace(value: string | number) {
    return value.toString().replace(/\s+/g, "");
}

function isOnlyWithDigits(value: string) {
    return value === "" || /^\d+$/.test(value);
}
import {CSSProperties, forwardRef, useEffect, useMemo, useRef, useState} from "react";
import classNames from "classnames";

import {ManualPopover} from "@pg-design/floating-module";
import {SlimRange} from "@pg-design/range-module";

import {IMaxValueInputProps} from "../../types/IMaxValueInputProps";
import {getNumberFormat} from "../../utils/get_number_format";
import {Input} from "../input/Input";

import * as cns from "./MaxValueInput.module.css";

export const MaxValueInput = forwardRef<HTMLInputElement, IMaxValueInputProps>((props, forwardedRef) => {
    const {step, min, max, name, value, onChange, ...inputProps} = props;

    const [displayValue, setDisplayValue] = useState<number | string>(getNumberFormat(value ?? 0));
    const [warning, setWarning] = useState({isOpen: false, message: ""});
    const [inputWidth, setInputWidth] = useState(`${displayValue.toString().length}ch`);

    const warningHideRef = useRef<null | ReturnType<typeof setTimeout>>(null);
    const measureSpanRef = useRef<null | HTMLSpanElement>(null);

    const rangeValue = useMemo(() => {
        const noWs = getWithoutWhiteSpace(displayValue);

        return {
            upper: parseInt(noWs)
        };
    }, [displayValue]);

    useEffect(() => {
        const hiddenSpanObserver = new ResizeObserver((entries) => {
            for (const entry of entries) {
                setInputWidth(`${entry.contentRect.width}px`);
            }
        });

        if (measureSpanRef.current) {
            hiddenSpanObserver.observe(measureSpanRef.current);
        }

        return () => {
            hiddenSpanObserver.disconnect();
        };
    }, []);

    useEffect(() => {
        if (warning.isOpen) {
            warningHideRef.current = setTimeout(() => {
                setWarning({isOpen: false, message: warning.message});
            }, 2000);
        }

        return () => {
            if (warningHideRef.current) {
                clearTimeout(warningHideRef.current);
                warningHideRef.current = null;
            }
        };
    }, [warning.isOpen]);

    useEffect(() => {
        if (onChange) {
            const numValue = getWithoutWhiteSpace(displayValue);
            onChange(parseInt(numValue));
        }
    }, [displayValue]);

    return (
        <div
            className={cns.maxValueInput}
            style={
                {
                    "--input-width": inputWidth
                } as CSSProperties
            }
        >
            <SlimRange
                name={`${name}_range`}
                value={rangeValue}
                useDynamicChange
                onChange={(_, value) => {
                    if (value.upper) {
                        setDisplayValue(getNumberFormat(value.upper));
                    }
                }}
                step={step}
                min={min}
                max={max}
                className={classNames(cns.maxValueInputRange, inputProps.disabled && cns.maxValueInputRangeDisabled)}
                hideLabels
                disabled={inputProps.disabled}
            />
            <ManualPopover
                popover={warning.message}
                isOpen={warning.isOpen}
                type="warning"
                handleSetIsOpen={(isWarningOpen) => {
                    setWarning({isOpen: isWarningOpen, message: warning.message});
                }}
                className={cns.maxValueInputPopover}
            >
                {({refs, getReferenceProps}) => (
                    <div ref={refs.setReference} {...getReferenceProps()} className={cns.maxValueInputField}>
                        <span className={cns.maxValueInputHiddenSpan} ref={measureSpanRef}>
                            {displayValue}
                        </span>
                        <Input
                            ref={forwardedRef}
                            name={name}
                            {...inputProps}
                            value={displayValue}
                            inputWrapClassName={cns.maxValueInputWrapper}
                            inputClassName={cns.maxValueInputCore}
                            elementCustomClassName={classNames(
                                cns.maxValueInputCoreRightElement,
                                typeof inputProps.rightElement === "string" && inputProps.disabled && cns.maxValueInputDisabledStringElement
                            )}
                            onChange={(event) => {
                                const newValue = event.currentTarget.value;
                                const valueWithoutWhiteSpace = getWithoutWhiteSpace(newValue);
                                const isValueWithDigitsOnly = isOnlyWithDigits(valueWithoutWhiteSpace);

                                const newValueInt = parseInt(valueWithoutWhiteSpace) | 0;

                                if (!isValueWithDigitsOnly && !warning.isOpen) {
                                    setWarning({
                                        isOpen: true,
                                        message: "Dozwolone są tylko cyfry"
                                    });
                                    return;
                                }

                                if (isValueWithDigitsOnly && newValueInt < min) {
                                    setWarning({
                                        isOpen: true,
                                        message: `Minimalna wartość: ${min}`
                                    });
                                    setDisplayValue(getNumberFormat(min));
                                    return;
                                }

                                if (isValueWithDigitsOnly && newValueInt > max) {
                                    setWarning({
                                        isOpen: true,
                                        message: `Maksymalna wartość: ${max}`
                                    });
                                    setDisplayValue(getNumberFormat(max));
                                    return;
                                }

                                if (isValueWithDigitsOnly && newValueInt >= min && newValueInt <= max) {
                                    setDisplayValue(getNumberFormat(newValueInt));
                                    return;
                                }
                            }}
                        />
                    </div>
                )}
            </ManualPopover>
        </div>
    );
});

// Utils
function getWithoutWhiteSpace(value: string | number) {
    return value.toString().replace(/\s+/g, "");
}

function isOnlyWithDigits(value: string) {
    return value === "" || /^\d+$/.test(value);
}
